import { Action, Alert, TextInput } from 'corso-admin-ui';
import { useState } from 'react';
import {
  SupportedClaimLineItem,
  useIsLocked,
} from '~/features/claimReview/ClaimReviewProvider';
import useClaimLineItemUpdate from '~/features/claimReview/hooks/useClaimLineItemUpdate';

export default function ClaimLineItemNoteToCustomer({
  claimLineItem,
}: {
  claimLineItem: SupportedClaimLineItem;
}) {
  const originalNoteToCustomer = claimLineItem.noteToCustomer ?? null; // ? do we want to instead make the note nullable when returned from the API
  const [noteToCustomer, setNoteToCustomer] = useState(originalNoteToCustomer);
  const isLocked = useIsLocked(claimLineItem);
  const { mutate, isPending, isError } = useClaimLineItemUpdate(
    claimLineItem.id,
  );

  if (isLocked) return null;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        mutate({
          kind: 'note',
          noteToCustomer,
        });
      }}
    >
      {/* // TODO log error */}
      {isError && (
        <Alert
          variant="critical"
          heading="Note Failed to Save. Please try again."
        />
      )}
      <TextInput
        id={`line-item-comment-${claimLineItem.id}`}
        label="Note to Customer"
        value={noteToCustomer}
        onChange={(e) => setNoteToCustomer(e.target.value || null)} // nullify empty strings
        addon={{
          outsideEnd: originalNoteToCustomer !== noteToCustomer && (
            <Action
              variant="primary"
              type="submit"
              disabled={isPending}
              loading={isPending}
            >
              Save
            </Action>
          ),
        }}
      />
    </form>
  );
}
